import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=223daf3a&scoped=true&"
var script = {}
import style0 from "./EmptyLayout.vue?vue&type=style&index=0&id=223daf3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223daf3a",
  null
  
)

export default component.exports